import { FontWeight, FontStyle } from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import { BitmapTextStyleOptions, TextStyleOptions } from "../../../core/setting/text/IText";


export class TextStyleConfig{

    static readonly MISSING_TEXT:TextStyleOptions = {
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 10,
        dropShadowDistance: 2,
        fontFamily : "Open Sans",
        fontWeight : FontWeight.EXTRA_BOLD,
        align: "center",
        fontSize: 46,
        fill: [
            "white",
        ]
    };

    static readonly DEFAULT_BUTTON_TEXT_STYLE: TextStyleOptions = {
        fontFamily: "Open Sans",
        fontStyle: FontStyle.ITALIC,
        fontSize: 34,
        fill: "#ffffff",
        fontWeight: FontWeight.EXTRA_BOLD
    };

    static readonly BONUS_RESULT_TEXT:TextStyleOptions = {
        fontFamily : "Helvetica",
        fontWeight : FontWeight.EXTRA_BOLD,
        fontStyle : FontStyle.ITALIC,
        align: "center",
        
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 4,
        dropShadowDistance: 7,
        fill: [
            "#ffffff",
            "#7792a5"
        ],
        fontSize: 48,
        miterLimit: 0,
        stroke: "#003366",
        strokeThickness: 3
    };

    static readonly MAX_WIN_TEXT:TextStyleOptions = 
        {
            "dropShadow": true,
            "dropShadowAlpha": 0.5,
            "dropShadowAngle": 1.7,
            "dropShadowBlur": 7,
            "dropShadowDistance": 7,
            "fill": [
                "#FFFFFF",
                "#B51A00"
            ],
            "fillGradientStops": [
                0.3
            ],
            "fontFamily": "Helvetica",
            "fontSize": 36,
            "fontStyle": "italic",
            "fontWeight": "bold",
            "strokeThickness": 3
        }

    static readonly TOTAL_XWAYS:TextStyleOptions = {
        fontFamily : "Helvetica",
        fontStyle : FontStyle.ITALIC,
        fontSize : 35,
        fontWeight : FontWeight.BOLD,
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 4,
        dropShadowDistance: 4,
        dropShadowColor: "#AAAC00",
        fill: "#F0F0F0",
    };

    static readonly BIT_COUNTER_WIN: BitmapTextStyleOptions = {
        fontName:  "NumbersWinCountUp",
        fontSize: 48,
        tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
    };
    

    static readonly XWAYS_WIN:TextStyleOptions = {
        fontFamily : "Helvetica",
        fontStyle : FontStyle.ITALIC,
        fontSize : 32,
        fontWeight : FontWeight.EXTRA_BOLD,
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 8,
        dropShadowDistance: 8,
        fill: "#FFFFFF",
        lineJoin: "round",
        stroke: "#FF2600",
        strokeThickness: 8
    };

    static readonly FS_RESULT_COUNTER:TextStyleOptions = {
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 20,
        dropShadowDistance: 20,
        fill: [
            "white",
            "#FFFC00",
            "#F68A0C"
        ],
        fontSize: 154,
        fontStyle: FontStyle.OBLIQUE,
        fontWeight: FontWeight.ULTRA_BOLD,
        miterLimit: 0,
        stroke: "#FF3304",
        strokeThickness: 6
    };

    static readonly FS_POSTER_COUNTER:TextStyleOptions = {
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 20,
        dropShadowDistance: 20,
        fill: [
            "white",
            "#FFFC00",
            "#F68A0C"
        ],
        fontSize: 192,
        fontStyle: FontStyle.ITALIC,
        fontWeight: FontWeight.ULTRA_BOLD,
        miterLimit: 0,
        stroke: "#FF3304",
        strokeThickness: 6
    };

    static readonly COLLECT_TEXT:TextStyleOptions = {
        fontFamily : "Helvetica",
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 4,
        dropShadowDistance: 7,

        fontStyle : FontStyle.ITALIC,
        fontWeight : FontWeight.ULTRA_BOLD,
  
        fill: [
            "white",
            "#FFFC00",
            "#f60"
        ],
        fontSize: 66,
        miterLimit: 0,
        stroke: "#c00",
        strokeThickness: 3
    };

    static readonly TOTAL_WIN:TextStyleOptions = {
        fontFamily : "Helvetica",
        fontStyle : FontStyle.ITALIC,
        fontWeight : FontWeight.EXTRA_BOLD,
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 8,
        dropShadowDistance: 12,
        fill: [
            "#ffffff",
            "#FFFC00"
        ],
        fontSize: 72,
        miterLimit: 0,
        stroke: "#FF6A00",
        strokeThickness: 2
    };

    static readonly BAR_REVEALER_TEXT:TextStyleOptions = {
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 4,
        dropShadowDistance: 4,
        fill: [
            "#FFFC00",
            "#F68A0C"
        ],
        fontSize: 54,
        fontStyle: "oblique",
        fontWeight: "bolder",
        lineJoin: "round",
        stroke: "#434343",
        strokeThickness: 4
    };

    static readonly MULTIPLIER_TEXT:TextStyleOptions = {
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 4,
        dropShadowDistance: 8,
        fill: "#FFFC00",
        fontSize: 42,
        fontStyle: "oblique",
        fontWeight: "bolder",
        lineJoin: "round",
        miterLimit: 4,
        strokeThickness: 4
    };

}
